"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COPYRIGHT_WITH_LINKS = void 0;
const COPYRIGHT_WITH_LINKS = exports.COPYRIGHT_WITH_LINKS = 'copyright-with-links';